import { SortingType } from "./types";

export const dropdownOptions = [
  {
    id: 0,
    title: "Сортирай по...",
    sortingType: SortingType.none,
  },
  {
    id: 1,
    title: "Първо препоръчани",
    sortingType: SortingType.recommended,
  },
  {
    id: 2,
    title: "Марка (А-Я)",
    sortingType: SortingType.brandasc,
  },
  {
    id: 3,
    title: "Марка (Я-А)",
    sortingType: SortingType.branddesc,
  },
  {
    id: 4,
    title: "Цена (възходящ)",
    sortingType: SortingType.priceasc,
  },
  {
    id: 5,
    title: "Цена (низходящ)",
    sortingType: SortingType.pricedesc,
  },
];
